import { Flex } from '@chakra-ui/react';
import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';

export function ProviderSelector({
  providerOptions,
  selectedProviders = [],
  onChange,
}: {
  selectedProviders: string[];
  providerOptions: {
    id: string;
    value: string;
    label: string;
  }[];
  onChange: (newFilters) => void;
}) {
  return (
    <Flex gap={2}>
      <MultipleChoiceFilter
        items={providerOptions}
        label="Providers"
        name="tenantIds"
        value={selectedProviders.join(',')}
        showSearch={false}
        onFilterChange={onChange}
      />
    </Flex>
  );
}
